import { createFileRoute } from "@tanstack/react-router";
import { SignInForm } from "@/features/auth/components/SignInForm";
import { useT } from "@/shared/i18n";
import { AuthShell } from "@/shared/layout/AuthShell";

export const Route = createFileRoute("/auth/sign-in")({
  component: SignInPage,
});

function SignInPage() {
  const t = useT();
  return (
    <AuthShell
      title={t("auth.signInTitle")}
      subtitle={t("auth.signInSubtitle")}
    >
      {/* Sign-up footer temporarily disabled while registration is closed. */}
      <SignInForm />
    </AuthShell>
  );
}
